// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class ArchiveCardsArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.ArchiveCardsArgs';
  $t: string = 'SagaBase.Defines.ArchiveCardsArgs';

  public static GetMembers(): string[] {
    return ['TriggeringEvents', 'ObjIds', 'ArchiveTypeId', 'UserId', 'StationId', 'UserName', 'CardType', 'AtomicLists'];
  }

  public GetMembers(): string[] {
    return ArchiveCardsArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public TriggeringEvents: any[];
  public ObjIds: Guid[];
  public ArchiveTypeId: number;
  public UserId: number = 0;
  public StationId: number = 0;
  public UserName: string;
  public CardType: string;
  public AtomicLists: any[];

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
